import AxiosInatance from "axios";
import config from "./config";
import history from './history';
import CryptoJS from 'crypto-js';
import { localStorageLogoutConditions } from "../utils/services";
import { showToast } from "./functions";
import { lsGet, lsSet } from '../utils/hooks';

const multipartFormDataRoutes =
  ["/inventory/saveInventoryWithExcel",
    "/areaMapping/updateMasterId",
    "/ASN/bulkASNItemUpload",
    "/sales/bulkSalesOrderItemUpload",
    "/ASN/saveMultiASN",
    "/sales/saveMultiSalesOrder",
    "inventory/multiASNReceiving",
    "/inventory/bulkUploadRawStock",
    "/inventory/bulkSerricoTrapToGridMapping",
    "/inventory/bulkReplaceSerricoTrap",
    "sales/createDispatchPlan",
    "job/verifyDispatchPlan",
    "job/excelJobCompletion",
    "job/verifyPreShipmentInpection",
    "/inventoryAdjustment/adjustmentExcelUpload",
    "inventory/uploadSKUImages",
    "ASN/verifyStockTransferReceiving",
    "inventory/saveUIDForQtyWiseLabel",
  ];

export const encryptData = (data) => {
  const secretKey = '12345678901234567890123456789012';
  const key = CryptoJS.enc.Utf8.parse(secretKey);

  // Generate a random IV
  const iv = CryptoJS.lib.WordArray.random(16);

  // Encrypt the data
  const encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7,
    iv: iv
  });

  // Prepend the IV to the encrypted data
  return iv.toString() + encrypted.toString();
};


// The below function we are using to encrypt the payload data in forgot and change password and login
export const encryptTheData = (data) => {
  let _key = CryptoJS.enc.Utf8.parse("pAUGvR0awF5ot2N5");
  let _iv = CryptoJS.enc.Utf8.parse("pAUGvR0awF5ot2N5");
  let encrypted = CryptoJS.AES.encrypt(JSON.stringify(data), _key,
    {
      keySize: 16,
      iv: _iv,
      mode: CryptoJS.mode.ECB,
      padding: CryptoJS.pad.Pkcs7
    });
  return encrypted.toString();
}

const axios = AxiosInatance.create({
  baseURL: config.baseURL || "/v1/",
  headers: {
    "Content-Type": "application/json",
  }
});

var token2 = "Bearer eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJ0b2tlbiI6eyJjcmVhdGVkRGF0ZSI6IjIwMjMtMDYtMTZUMDU6NTM6NDUuNjU1Wi02NDM3OWM2NmMzNDJmMDA0ZGQwZmEyOGQiLCJwZXJtaXNzaW9ucyI6eyJpbmRvb3JUcmFja2luZyI6dHJ1ZX0sIl9pZCI6IjY0Mzc5YzY2YzM0MmYwMDRkZDBmYTI4ZCIsInVzZXJUeXBlIjoiYWRtaW4iLCJuYW1lIjoiRXhwZXJpZW5jZSBDZW50ZXIiLCJlbWFpbCI6ImV4cGVyaWVuY2VAbHlua2l0LmluIiwiaXNPbkR1dHkiOmZhbHNlLCJhcHByb3ZlZCI6dHJ1ZSwiY29tcGFueSI6IkV4cGVyaWVuY2UgQ2VudGVyIiwiYmFzZSI6IjEzNjQyN2M3LTJjYWMtNDUxNS04MWFkLWI4YWJkNDZiZGYzNy0xNjgxMzY1OTkxNzc4IiwiZGVzaWduYXRpb24iOiJFeHBlcmllbmNlIn0sImlhdCI6MTY4Njg5NDgyNSwiZXhwIjo2LjMxMTM5MDQ4ODg4ODkwNmUrMjN9.kNejXKM2eYzdE8o-nyfsR32opgBBQxDW0SQQyUnUBbs"

// ---- Smart Toast Controller (Deduplicated + Cooldown) ----
const TOAST_COOLDOWN_TIME = 3000; // 3 seconds

const toastCooldownMap = {
  NETWORK: false,
  SERVER: false,
};

let maintenanceOpened = false;

// Track ERR_NETWORK failures in a short window to distinguish
// individual API timeouts (2-3 fail) vs server down (all fail at once)
const ERR_NETWORK_WINDOW = 3000; // 3 second window
const ERR_NETWORK_THRESHOLD = 3; // if 3+ APIs fail within window → server is down
let errNetworkTimestamps = [];

function openMaintenancePage() {
  if (maintenanceOpened) return;
  maintenanceOpened = true;
  history.push("/maintenance");
}

// Call this when leaving maintenance page (e.g. when health check succeeds and redirects to dashboard)
export function resetMaintenanceFlag() {
  maintenanceOpened = false;
  errNetworkTimestamps = [];
}

function showSmartToast(type, message, isError = true) {
  if (toastCooldownMap[type]) {
    return; //  Already showing / recently shown
  }

  toastCooldownMap[type] = true;

  showToast(message, isError);

  setTimeout(() => {
    toastCooldownMap[type] = false; //  Allow again after cooldown
  }, TOAST_COOLDOWN_TIME);
}


axios.interceptors.request.use(function (config) {
  // Do something before request is sent
  // console.log("config>>>>>>",config)

  let project = lsGet("project")
  if (project) {
    config.headers["project"] = project
  }

  if (multipartFormDataRoutes.includes(config.url)) {
    config["headers"]["Content-Type"] = 'multipart/form-data'
  }
  if (config.url.includes("getAllUserData")) {
    config["headers"]["Authorization"] = token2
  }
  else if (["ESO/getESOFormConfigDetail", "ESO/submitESOResponse"].includes(config.url) && lsGet("passToken") && config["headers"]) {
    config["headers"]["partialaccesstoken"] = lsGet("passToken")
  }
  else if (lsGet("token") && config["headers"]) {
    // if (config.data) {
    //   config = {
    //     ...config,
    //     "data": {"encryptedData":encryptData(config.data)}
    //   };
    //   console.log(config,"uuu",encryptData(config.data))
    // }
    config["headers"]["Authorization"] = lsGet("token")
  }
  // === Attach Socket ID ===
  const socket = window.currentSocket;

  if (socket && socket.connected && socket.id) {
    config.headers['x-socket-id'] = socket.id;        // Best header name
    // OR you can use: config.headers['socket-id'] = socket.id;
  }
  return config;
}, function (error) {
  // Do something with request error
  return Promise.reject(error);
});

axios.interceptors.response.use(function (response) {

  // Do something with response data
  let { config: { url }, data: { inValidToken = false, message } } = response

  
  // //("response>>>", {inValidToken,url});
  if (url && !url.includes("getAllUserData") && inValidToken) {//response.status == 201 &&
    localStorageLogoutConditions()
    lsSet("TokenExpirymesssage", message || "Session expired, please logout and login again!");

    history.push("/login")
    // window.location.href = '/';
  }

  return response

}, function (error) {
  // Do something with response error
  console.log("error.response>>>", error);
  const status = error?.response?.status;
  const requestUrl = error?.config?.url || '';
  const errorCode = error?.code || '';

  // Skip maintenance redirect for health check calls (maintenance page handles its own retries)
  const isHealthCheck = requestUrl.includes('/health');

  // If maintenance page is already open, suppress all error toasts
  if (maintenanceOpened) {
    return Promise.reject(error);
  }

  // 504 Gateway Timeout → single API timeout, server is still running
  if (status === 504) {
    showSmartToast(
      "SERVER",
      "Request timed out (504). Please try again.",
      true
    );
  }
  // ✅ ONLY true server down cases (502, 503 = server confirmed unreachable)
  else if ([502, 503].includes(status)) {
    if (!isHealthCheck) openMaintenancePage();
  }
  // ERR_NETWORK → could be individual API timeout (2-3 fail) or server down (all fail at once)
  // Track failures in a short window: if many APIs fail together → server is down
  else if (errorCode === "ERR_NETWORK") {
    const now = Date.now();
    // Remove timestamps older than the window
    errNetworkTimestamps = errNetworkTimestamps.filter(t => now - t < ERR_NETWORK_WINDOW);
    errNetworkTimestamps.push(now);

    if (errNetworkTimestamps.length >= ERR_NETWORK_THRESHOLD) {
      // Many APIs failing together → server is truly down
      errNetworkTimestamps = [];
      if (!isHealthCheck) openMaintenancePage();
    } else {
      // Only a few APIs failed → just a timeout, show toast
      showSmartToast("SERVER", "Request failed. Please try again.", true);
    }
  }
  //  Network issues → DO NOT open maintenance
  else if (!error?.response) {
    showSmartToast(
      "NETWORK",
      "Network issue. Please check your connection.",
      true
    );
  }
  //  Timeout / canceled
  else if (errorCode === 'ECONNABORTED' || errorCode === 'ERR_CANCELED') {
    showSmartToast(
      "NETWORK",
      "Request timed out. Please try again.",
      true
    );
  }
  //  Other server errors
  else if (status >= 500) {
    showSmartToast(
      "SERVER",
      "Something went wrong. Please try again later.",
      true
    );
  }
  // ✅ Payload too large
  else if (status == 413) {
    showSmartToast(
      "SERVER",
      "Payload too large. Please try again later.",
      true
    );
  }
  return Promise.reject(error);
});


export default axios;
